import { queryOptions } from '@tanstack/react-query';

import { fetchMe, type StaffMember, type StaffRole } from './api';

/**
 * Текущая сессия сотрудника.
 *
 * Токен лежит в httpOnly-cookie и фронтенду не виден, поэтому «вошёл или нет» — не флаг
 * в состоянии приложения, а ответ `/me`. Отсюда и кэш: один запрос на вкладку, повторная
 * проверка при возврате в окно, а всё остальное — производные от него.
 */
export const meQueryOptions = queryOptions({
  queryKey: ['auth', 'me'],
  queryFn: fetchMe,
  // Сессия живёт 12 часов без продления, но истечь может и раньше — блокировкой сотрудника
  // или выходом с другой вкладки. Минута — компромисс между лишними запросами и работой
  // в интерфейсе, из которого уже выкинули.
  staleTime: 60_000,
  // Ретрай бессмысленен: 401 не изменится от повтора, а вход тем временем ждёт ответа.
  retry: false,
});

export const roleLabels: Record<StaffRole, string> = {
  ADMINISTRATOR: 'Администратор',
  ORDER_MANAGER: 'Менеджер заказов',
  CONTENT_MANAGER: 'Контент-менеджер',
};

/**
 * Инициалы для аватара: «Семенченко Дмитрий» → «СД».
 *
 * Берутся первые буквы двух первых слов — у сотрудников в системе полное имя, а не логин.
 * Если слово одно, остаётся одна буква: две буквы из одного слова («СЕ») читаются как опечатка.
 */
export function initialsOf(fullName: string): string {
  return fullName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
}

export type { StaffMember, StaffRole };
